import { queryCache } from "react-query";
import { QUERY_KEYS } from "../../../../constants";
import useMajorQueries from "../../../major/hooks/useMajorQueries";
import { NotifyMode } from "../../../notify/NotifyModeEnum";
import { useNotify } from "../../../notify/useNotify";
import { IWizardConfig, WizardMode } from "../../../wizard/types";
import AddMajorContent from "../components/step1/AddMajor";
import addMajorValidator from "../higher/validators/step1/addMajorValidator";

async function createMajor(data, fetchCreate, snackNotify) {
  const { majors } = QUERY_KEYS;
  if (data.id) {
    return { data: { id: data.id, name: data.name } };
  }

  const result = await fetchCreate({ name: data.name.trim() });
  await queryCache.invalidateQueries(majors);
  snackNotify(
    "Success",
    "The major has been successfully created",
    NotifyMode.SUCCESS,
  );
  return { data: { id: result.data.id, name: result.data.name } };
}

export function useAddMajorConfig(): IWizardConfig {
  const { fetchCreate } = useMajorQueries();
  const snackNotify = useNotify();

  return {
    steps: [
      {
        width: "650px",
        titleConfig: {
          titleText: "Add major",
        },
        content: AddMajorContent,
        validator: addMajorValidator,
      },
    ],
    saveCallback: (data) => createMajor(data, fetchCreate, snackNotify),
    submitButtonText: "Add",
    cancelButtonText: "Close",
    showSuccessNotification: false,
    mode: WizardMode.Create,
  };
}
